import * as React from 'react';
const SvgSlashBack = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M17.312 22a.937.937 0 0 1-.81-.463L5.877 3.412a.94.94 0 0 1 1.62-.948l10.625 18.124a.938.938 0 0 1-.81 1.412Z", fill: "currentColor" })));
export default SvgSlashBack;
